var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:#186c4a}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m3.2 17.4c2.2-5.4 2.9-7.5 5.2-9.6q3.5-3.2 7.6-4.7q4.2-1.5 8.8-1.4q4.7 0.1 9 2q4.3 2 7.4 5.5q3.2 3.4 4.7 7.5q1.5 4.2 1.4 8.9q-0.1 4.7-2.1 9q-2.4 5.2-6.9 8.7q-4.4 3.5-9.9 4.5q-5.5 1.1-10.9-0.5l0.9-1.5c3.8 0.8 11.9-2.3 15.5-4c3.5-1.8 6.4-6.3 8.1-9.9c0.9-2.1 1-7.3 1-9.5c0.1-2.3-1.8-4.6-2.5-6.6c-0.7-1.9-2-2.9-3.5-4.5c-1.4-1.7-4.3-2.5-6.3-3.4c-2.1-0.9-4.9-0.7-7.2-0.7c-2.2-0.1-4.3 0.7-6.3 1.4c-2 0.7-3.8 2.3-5.5 3.8c-1.6 1.5-2.6 4.2-3.6 6.2c-1.6 3.7-2.7 11.6-0.1 13.8c6.4 5.1 2.5 10.4-2.5 5.5c-2.7-2.6-3.3-7.9-3.5-11.7c-0.1-3.7-1-3.4 1.2-8.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircled);
export default __webpack_public_path__ + "static/media/Circled.90ab955b303f6dbcecd33888608e9de2.svg";
export { ForwardRef as ReactComponent };